export enum RepeatType {
  ONCE = 'once',
  DAILY = 'daily',
  SELECTED = 'selected',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}
